import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from 'reactstrap';
import { withUserAgent } from 'core/hocs';
import { DEVICES_TYPES } from 'core/constants';

import './custom-tooltip.scss';

export class CustomTooltipUI extends Component {
  state = {
    isTooltipOpen: false
  }

  eventsHandler = ({ type }) => {
    const { deviceType } = this.props;
    const isDesktop = deviceType === DEVICES_TYPES.DESKTOP;

    switch (type) {
      case 'mouseenter': {
        if (isDesktop) {
          this.setState({ isTooltipOpen: true });
        }

        break;
      }

      case 'mouseleave': {
        this.setState({ isTooltipOpen: false });

        break;
      }

      default: {
        this.setState(prevState => ({
          isTooltipOpen: !prevState.isTooltipOpen,
        }));
      }
    }
  };

  render() {
    const {
      id, className, Icon, children, placement, container,
    } = this.props;
    const { isTooltipOpen } = this.state;

    return (
      <>
        <span
          tabIndex="0"
          role="button"
          onClick={this.eventsHandler}
          onKeyPress={this.eventsHandler}
          onMouseEnter={this.eventsHandler}
          onMouseLeave={this.eventsHandler}
          id={id}
          className={className}
        >
          <Icon className={classNames('tooltip-btn-icon', { 'is-open': isTooltipOpen })} />
        </span>

        <Tooltip isOpen={isTooltipOpen} placement={placement} target={id} container={container}>
          {children}
        </Tooltip>
      </>
    );
  }
}

CustomTooltipUI.propTypes = {
  className: PropTypes.string,
  deviceType: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  container: PropTypes.string,
  Icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
};

CustomTooltipUI.defaultProps = {
  className: '',
  placement: 'bottom',
  container: 'body',
};

export const CustomTooltip = withUserAgent(CustomTooltipUI);
